module.exports = __webpack_public_path__ + "img/DSC00552-cropped-compressed.6ef97a54.webp";